import { Library } from ".."
import whiteLabel from "../whitelabel"

const rdam: Library = {
  ...whiteLabel,
}

export default rdam